import Inspector from './inspector';
import { SelectFAQPosts } from '../__components/select-faq-posts';
import { SelectFAQGroups } from '../__components/select-faq-groups';
import { ServerSideRenderX } from '../__components/server-side-render-x';

const { Component, Fragment } = wp.element;
const { ServerSideRender } = wp;
const { applyFilters, doAction } = wp.hooks;
const merge = require('deepmerge');
const classnames = require('classnames');

class Edit extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { setAttributes } = this.props;

		//console.log('componentDidMount[text]: EDIT.JS');

		// Compare current block attribute with the default 'text_expand' theme to make sure existing blocks pickup any new style settings added to the plugin. This should work for core and custom themes.
		const merge_attr = merge.all([
			flexible_faqs_editor_data.text_expand.default.faq_attributes,
			this.props.attributes,
		]);

		//console.log('merge_attr: ', merge_attr);
		setAttributes(merge_attr);
	}

	render() {
		const {
			attributes: { faq_group_toggle, faqGroupId, faqPostId },
			attributes,
			setAttributes,
			isSelected,
		} = this.props;

		//doAction('add-components', attributes);
		//doAction('test3');

		// add custom attributes
		const custom_attributes = applyFilters(
			'flexible-faqs-custom-attributes',
			{},
			attributes
		);

		return (
			<Fragment>
				{isSelected && (
					<Fragment>
						{faq_group_toggle ? (
							<SelectFAQGroups
								faq_group_toggle={faq_group_toggle}
								faqGroupId={faqGroupId}
								setAttributes={setAttributes}
							/>
						) : (
							<SelectFAQPosts
								faq_group_toggle={faq_group_toggle}
								faqPostId={faqPostId}
								setAttributes={setAttributes}
							/>
						)}
						<hr style={{ margin: '20px 0 15px 0' }} />
					</Fragment>
				)}
				<ServerSideRenderX
					block="flexible-faqs/text-expand-faqs"
					attributes={attributes}
				/>
				{ /* <ServerSideRender
					block="flexible-faqs/text-expand-faqs"
					attributes={attributes}
				/> */ }
				<Inspector
					attributes={attributes}
					setAttributes={setAttributes}
					blockProps={this.props}
				/>
			</Fragment>
		);
	}
}

export default Edit;
